export const TRIAL_NOT_STARTED_TOOLTIP = 'Your trial will start once you create your first pipeline';
